import React from "react";

export default function MessageNotification(props) {
  const { counter } = props;
  return <div className="s360-messageNotification-onlyCount">{counter}</div>;
}
